<template>
    <vx-card>
        <div class="vx-row ml-0">
            <div class="cursor-pointer" @click="$router.go(-1)">
                <feather-icon icon="ArrowLeftIcon" style="width:20px;vertical-align: middle;"/>
                <span class="ml-2" style="color:#277df6">Quay lại</span>
            </div>
        </div>
        <div class="mt-0 ml-2">
            <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" nextButtonText ="Tiếp tục" backButtonText="Đóng" finishButtonText="Bắt đầu" @on-complete="formSubmitted">
                <tab-content title="Mục tiêu" class="mb-5" icon="feather icon-home" :before-change="selectedBranding">

                    <!-- tab 1 content -->
                    <div class="vx-row ml-0 mb-2">    
                        <span class="title">Bạn muốn quan tâm theo dõi sản phẩm nào?</span>
                    </div>
                    <div class="vx-row mt-8">
                        <div class="vx-col md:w-1/2 mt-2 w-full" v-for="(itemTrade,indexTrade) in optionalTrademark" :key="indexTrade">
                            <vx-card :class="{'card-hover cursor-pointer card-selected' : itemTrade.selected, 'card-hover cursor-pointer' : !itemTrade.selected}" @click="selectedTrademark(itemTrade,indexTrade)" style="min-height:16rem">
                                <div class="pt-4 pl-12 pr-12 pb-4">
                                    <div class="vx-row">
                                        <feather-icon :icon="itemTrade.icon" svgClasses="feather-size"></feather-icon>
                                    </div>
                                    <div class="vx-row mt-2">
                                        <span class="text-title">{{itemTrade.label}}</span>
                                    </div>
                                    <div class="vx-row mt-2">
                                        <span>{{itemTrade.content}}</span>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </tab-content>

                <!-- tab 2 content -->
                <tab-content title="Thiết lập lĩnh vực" class="mb-5" icon="feather icon-briefcase" :before-change="selectedSourceTrade">
                    <div class="vx-row ml-0 mb-2">    
                        <span class="title">Bạn đang hoạt động trong lĩnh vực nào?</span>
                    </div>
                    <div class="vx-row mt-8">
                        <div class="vx-col md:w-1/4 mt-2 w-full" v-for="(item, indexOption) in optionalSource" :key="indexOption">
                            <vx-card :class="{'card-hover cursor-pointer card-selected' : item.selected, 'card-hover cursor-pointer' : !item.selected}" @click="selectedSource(item)" style="min-height:17rem">
                                <div class="pt-4 pl-12 pr-12 pb-4">
                                    <div class="vx-row feather-size">
                                        <feather-icon :icon="item.icon" svgClasses="feather-size" style="color:#277df6"></feather-icon>
                                    </div>
                                    <div class="vx-row mt-2">
                                        <span class="text-title">{{item.label}}</span>
                                    </div>
                                    <div class="vx-row mt-2">
                                        <span>{{item.content}}</span>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </tab-content>

                <!-- tab 3 content -->
                <tab-content title="Bắt đầu chiến dịch" class="mb-5" icon="feather icon-flag">
                    <div class="vx-row ml-0 mb-2">    
                        <span class="title">Thông tin về bạn</span>
                    </div>
                    <div class="vx-row mt-2">
                        <div class="vx-col mt-2 w-full">
                            <vx-card class="">
                                <div class="vx-row">
                                    <div class="vx-col md:w-1/2 w-full mt-2" style="border-right: 1px solid #ccc;">
                                        <div class="vx-row pl-4 pr-4">
                                            <div class="vx-col w-full">
                                                <span class="title-step-2">Tên chủ đề</span>
                                            </div>
                                            <div class="vx-col w-full mt-4">
                                                <vs-input v-model="form.topicName" class="w-full" name ="topicName"></vs-input>
                                                <span class="text-danger text-sm">{{
                                                    errors.first("topicName")
                                                }}</span>
                                            </div>
                                            <div class="vx-col w-full mt-2">
                                                <span class="title-step-2">Từ khoá chính</span>
                                            </div>

                                            <div class="vx-col w-full">
                                                <span>Tất cả thông tin thu thập sẽ bao gồm từ khoá này:</span>
                                            </div>

                                            <div class="vx-col w-full mt-4" v-for="(itemKey,indexKey) in form.keywords" :key="indexKey">
                                                <vue-simple-suggest
                                                v-model="itemKey.keyword"
                                                :list="simpleSuggestionList.map(el => el.topicName)"
                                                placeholder ="Tìm theo từ khóa..."
                                                data-vv-valuedate-on="blur"
                                                v-validate ="'required'"
                                                @suggestion-click="searchByKeyword"
                                                icon-pack="feather"
                                                icon="icon-search"
                                                :filter-by-query="true">
                                                </vue-simple-suggest>
                                            </div>

                                            <div class="vx-col w-full mt-4">
                                                <span>Bạn có thể bổ sung các từ khoá khác tại mục "Quản lý từ khoá" từ màn hình chính, sau khi đã bấm vào nút "Bắt đầu"</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="vx-col md:w-1/2 w-full mt-2">
                                        <div class="vx-row pl-4 pr-4">
                                            <div class="vx-col w-full">
                                                <span class="title-step-2">Các từ khoá phụ</span>
                                            </div>

                                            <div class="vx-col w-full">
                                                <span>Đây là các từ khoá hỗ trợ việc thu thập thông tin được chính xác hơn:</span>
                                            </div>

                                            <div class="vx-col w-full mt-4" v-for="(item,keyTags) in tagsListAction" :key="keyTags">
                                                <vue-tags-input style = "margin-top: 0px !important; max-width:100% !important"
                                                v-validate="'max:255'"
                                                placeholder="Tin bài chứa các từ khóa spam, rác sẽ không được thu thập."
                                                v-model="item.tag2"
                                                :tags=item.action
                                                @tags-changed="newTags => item.action = newTags"
                                                allow-edit-tags
                                                >
                                                </vue-tags-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </tab-content>
            </form-wizard>
        </div>
    </vx-card>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VueTagsInput from '@johmun/vue-tags-input';
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'

export default {
    components:{
        VueTagsInput,
        FormWizard,
        TabContent,
        VueSimpleSuggest
    },
    data() {
        return {
            form:{
                keywords:[
                    {
                    action:[],
                    keyword:null
                    }
                ],
                excludeKeyword:[],
                topicName:null,
                domainWeb:null,
                favourite:false,
                articleSource:[],
                topicGroupId:null,
                topicRelationship:null,
                domainFacebook:null,
                domainYoutube:null,
                domainOther:null
            },
            simpleSuggestionList:[],
            tagsListAction:[{
                action:[]
            }],
            optionalSource:[
                {icon:'ActivityIcon',label:'Tài chính', selected: false, value: 1, content: 'Các lĩnh vực: Ngân hàng, Bảo hiểm, Chứng khoán và các hoạt động tiền tệ khác'},
                {icon:'BarChart2Icon', label:'Bất động sản', selected: false, value: 2, content: 'Các lĩnh vực: Chủ đầu tư dự án bất động sản, Sản và các đại lý bất động sản.'},
                {icon:'ShoppingCartIcon', label: 'Đồ tiêu dùng', selected: false, value: 3, content: 'Các lĩnh vực: Thương mại điện tử, Sản xuất, phân phối, bán buôn và bán lẻ hàng tiêu dùng'},
                {icon:'SearchIcon', label: 'Marketing', selected: false, value: 4, content: 'Các lĩnh vực: Nghiên cứu thị trường, Đại lý quảng cáo, v.v.'}
            ],
            optionalTrademark:[
                {icon:'UserIcon',label:'Thương hiệu cá nhân', selected: false, value: 1, content: 'Theo dõi sự quan tâm trên mạng Internet đến thương hiệu cá nhân của bạn theo thời gian. Tìm kiếm cơ hội mới.'},
                {icon:'HomeIcon',label:'Thương hiệu tổ chức', selected: false, value: 2, content: 'Theo sát độ nhận diện thương hiệu. So sánh với các đối thủ cạnh tranh. Phản ứng'}
            ],
            user: {
                gender: null,
                city: null,
                district: null,
                subDistrict: null,
                address: null,
                houseNumber: null,
                password: "",
                rePassword: "",
                activeStatus: 0
            }
        }
    },
    methods: {
        selectedBranding: function(){
            return new Promise((resolve, reject) => {
                const result = this.optionalTrademark.filter(el => el.selected);
                if(result.length === 0){
                    resolve(false);
                    return this.$vs.notify({
                        text:'Vui lòng chọn sản phẩm quan tâm theo dõi',
                        icon:'icon-alert',
                        iconPack:'feather',
                        color:'danger'
                    })
                }
                resolve(true)
            })
        },
        selectedSourceTrade: function(){
            return new Promise((resolve, reject) => {
                const resultTrade = this.optionalSource.filter(el => el.selected);
                if(resultTrade.length === 0){
                    resolve(false)
                    return this.$vs.notify({
                        text:'Vui lòng chọn lĩnh vực theo dõi',
                        icon:'icon-alert',
                        iconPack:'feather',
                        color:'danger'
                    })
                }
                resolve(true)
            })
        },
        formSubmitted() {
            const data = this.form.topicName;
            if(!this.form.topicName || this.form.keywords[0].keyword.length == 0){
                return this.$vs.notify({
                    text:'Trường dữ liệu không được để trống',
                    icon:'icon-alert',
                    iconPack:'feaather',
                    color:'danger'
                })
            }
            if(this.form.articleSource && this.form.articleSource.length == 0){
                this.form.articleSource.push(101, 102, 103, 104, 105, 106, 108, 109, 110, 113);
            }
            
            let excludeKeyword = this.tagsListAction[0].action.map(el => el.text);
            if(this.form.keywords){
                this.form.keywords = this.form.keywords.map(keyword => {
                let action = [];
                if(keyword.action) {
                    action = keyword.action.map(action => {return action.text;}).filter(item => item);
                }
                return {
                    keyword: keyword.keyword,
                    action: action
                }
                });
            }
            const payload = {
                topicName: this.form.topicName,
                articleSource: this.form.articleSource,
                excludeKeyword: excludeKeyword,
                favourite: this.form.favourite,
                keywords: this.form.keywords,
                topicGroupId: this.form.topicGroupId,
                topicRelationship: this.form.topicRelationship,
                priority:0,
                viewTopic:true
            }
            const payloadUser = {
                fullName: this.user.fullName,
                email: this.user.email,
                phoneNumber: this.user.phoneNumber,
                gender: this.user.gender,
                birthday: this.user.birthday,
                organizationName: this.user.organizationName,
                city: this.user.city,
                district: this.user.district,
                subDistrict: this.user.subDistrict,
                houseNumber: this.user.houseNumber,
                fullAddress: this.user.fullAddress,
                password: this.user.password,
                firstLogin:false,
                allowNotify:0
            }
            this.$vs.loading();
            this.$business.post('topic/create', payload).then(() => {
                this.$oauth.post('/user/update-info', payloadUser).then(() => {
                    this.$vs.loading.close();
                    this.$router.push('/dashboard')
                })
            })
        },
        searchByKeyword: function(){

        },
        selectedTrademark: function(event, index){
            this.isTrademark = true;
            if(event.selected){
                event.selected = false;
            }
            else{
                event.selected = true;
            }
        },
        selectedSource: function(event){
            this.isSource = true;
            if (event.selected){
                event.selected = false;
            }else{
                event.selected = true;
            }
        },
        initScreen(){
            const payload ={

            }
            this.$processor.post('topic-trending/find-all-trending', payload).then((res) =>{
                this.simpleSuggestionList = res.data;
            })
        }
    },
    async created(){
        const nav = document.getElementsByClassName('vx-navbar-wrapper navbar-full p-0')[0];
        if (nav){
            nav.style.display ='none'
        }
        this.$oauth.get('/user/current').then((response) => {
            this.user = Object.assign({}, this.user, response.data);
         })
        this.initScreen();
        
    }
}
</script>
<style scoped>
.text-title{
    font-size: 24px;
    font-weight: bold;
}
.title{
    font-size: 28px;
    font-weight: bold;
    color: #277df6;
}
.card-selected{
    box-shadow: 0px 2px 5px 0px #277df6;
}
.title-step-2{
    font-size: 20px;
    /* font-weight: bold; */
    color: #277df6;
}
.feather-size{
    width: 4rem;
    height: 4rem;
    color: #277df6;
}
</style>
